<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
	  <face-sms></face-sms>
  </div>
</template>

<script>
import faceSms from './components/faceSms'
export default {
  name: 'app',
	components: {
  	    faceSms
	}
}
</script>

<style lang="scss">
  @import "./static/css/login.scss";
</style>



// WEBPACK FOOTER //
// src/Login.vue